import { render, staticRenderFns } from "./Type11.vue?vue&type=template&id=2d639f4a&scoped=true"
import script from "./Type11.vue?vue&type=script&lang=js"
export * from "./Type11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d639f4a",
  null
  
)

export default component.exports